// extracted by mini-css-extract-plugin
module.exports = {"imageCaption":"styles-module--imageCaption--2eXUM"};